import React from 'react';
import PropTypes from 'prop-types';
import { CheckboxLabel } from './Checkbox.style';
import { ABUtils } from '../../utils';

export const Checkbox = (props) => {
    const { id, checked, children, disabled, onChange } = props;
    const { isCssVariationMobile } = ABUtils.getABs();
    const wrapperClass = isCssVariationMobile ? 'prisma-selectable od-checkbox-wrapper-cobalt-variation' : '';
    const inputClass = isCssVariationMobile ? 'prisma-selectable-native' : 'odf-selectable-native';
    const labelClass = isCssVariationMobile ? 'prisma-selectable-content' : 'odf-selectable-content';
    const spanClass = isCssVariationMobile ? 'prisma-selectable-input prisma-checkbox-back' : 'odf-selectable-input odf-checkbox-back';
    const spanFillClass = isCssVariationMobile ? 'prisma-selectable-fill prisma-checkbox-fill' : 'odf-selectable-fill odf-checkbox-fill';
    return (
        <div className={wrapperClass}>
            <input
                id={id}
                type="checkbox"
                checked={checked}
                disabled={disabled}
                readOnly
                className={inputClass}
                onChange={onChange}
            />
            <CheckboxLabel className={labelClass} htmlFor={id} style={disabled ? { cursor: 'default' } : {}}>
                <div className="odf-flex-container-row odf-flex-container-nogutter">
                    <div className="odf-flex-item">
                        <span className={spanClass} style={disabled ? { cursor: 'default', borderColor: '#ccc' } : {}}>
                            <span className={spanFillClass} style={disabled ? { cursor: 'default', color: 'unset' } : {}}>
                                <span className="odf-icon odf-icon-tick" />
                            </span>
                        </span>
                    </div>
                    <div className="odf-flex-item odf-space-outer-left-s">{children}</div>
                </div>
            </CheckboxLabel>
        </div>
    );
};

Checkbox.propTypes = {
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
};

Checkbox.defaultProps = {
    checked: false,
    children: null,
    disabled: false,
};
